import { useRef, useEffect, useState } from 'react';
import { IndexLocationWithAlign, VirtuosoHandle } from 'react-virtuoso';

const SCROLL_OPTIONS = { behavior: 'smooth', align: 'center' } as Partial<IndexLocationWithAlign>;

const isBetween = (n: number, a: number, b: number): boolean => n > Math.min(a, b) && n < Math.max(a, b);

// Virtuoso's resize observer can this error,
// which is caught by DnD and aborts dragging.
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' || e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation();
  }
});

const useVirtuoso = ({ scrollToIndex }: { scrollToIndex?: number }) => {
  const virtuosoRef = useRef<VirtuosoHandle>(null);

  const [visibleRange, setVisibleRange] = useState({
    startIndex: 0,
    endIndex: 0,
  });

  const scrollIndexLocationWithAlign = {
    index: scrollToIndex || 0,
    ...SCROLL_OPTIONS,
  };

  useEffect(() => {
    if (scrollToIndex !== undefined && virtuosoRef && !isBetween(scrollToIndex, visibleRange.startIndex, visibleRange.endIndex)) {
      virtuosoRef?.current?.scrollToIndex(scrollIndexLocationWithAlign);
    }
  }, [scrollToIndex]);

  return {
    virtuosoRef,
    initialIndex: scrollIndexLocationWithAlign,
    visibleRange,
    setVisibleRange,
  };
};

export default useVirtuoso;
